/**
 * Network Locations — a one-photo-at-a-time carousel of the same
 * locations the list beside it renders. Deliberately not shared with
 * Photo Gallery's script: that track is a fractional multi-up strip and
 * this one is always exactly one full-width slide per step, so the
 * position math does not overlap between the two.
 *
 * The list and the carousel are never wired together — clicking a
 * location does not move the track, matching the prototype.
 *
 * No optional chaining or nullish coalescing: gulp-babel has no preset
 * configured, so uglify-js parses this as written.
 */
(function () {
  const blocks = document.querySelectorAll(".network-locations .nl-media");
  if (!blocks.length) return;
  function setup(media) {
    const track = media.querySelector(".nl-track");
    const prev = media.querySelector(".nl-prev");
    const next = media.querySelector(".nl-next");
    const fill = media.querySelector(".nl-fill");
    const now = media.querySelector(".nl-now");
    if (!track || !prev || !next) return;
    const slides = track.children;
    const total = slides.length;
    if (total < 2) return;
    let index = 0;
    function pad(n) {
      return n < 10 ? "0" + n : String(n);
    }
    function apply() {
      track.style.transform = "translate3d(" + -index * 100 + "%,0,0)";
      if (now) now.textContent = pad(index + 1);
      if (fill) fill.style.transform = "translateX(" + index * 100 + "%)";
      prev.disabled = index === 0;
      next.disabled = index === total - 1;
    }
    prev.addEventListener("click", function () {
      if (index > 0) {
        index--;
        apply();
      }
    });
    next.addEventListener("click", function () {
      if (index < total - 1) {
        index++;
        apply();
      }
    });
    apply();
  }
  for (let i = 0; i < blocks.length; i++) {
    setup(blocks[i]);
  }
})();